import React, { useContext } from "react";
import { themeContext } from "../../../Context";
import "./WhyLiteSoft.css";

const points = [
  {
    title: "أكثر من 800 عميل",
    desc: "ثقة منشآت في المملكة العربية السعودية واليمن ومختلف الدول العربية.",
  },
  {
    title: "سهولة التشغيل اليومي",
    desc: "واجهات واضحة للفريق المالي والتشغيلي تقلّل الاعتماد على إجراءات يدوية متفرقة.",
  },
  {
    title: "تكامل الوحدات والقطاعات",
    desc: "المبيعات والمشتريات والمخزون والحسابات مع أنظمة متخصصة لنشاط منشأتك في منصة واحدة.",
  },
  {
    title: "تدريب ودعم مستمر",
    desc: "متابعة بعد التشغيل مع دعم فني يساعدك على التأسيس والاستخدام اليومي.",
  },
  {
    title: "امتثال الفوترة الإلكترونية",
    desc: "الربط مع هيئة الزكاة والضريبة والجمارك ومنصة فاتورة عند حاجة منشأتك للمرحلة الثانية.",
  },
];

const WhyLiteSoft = () => {
  const theme = useContext(themeContext);
  const darkMode = theme.state.darkMode;

  return (
    <section className="why-litesoft" id="erp-why">
      <div className="erp-section-head">
        <h2 style={{ color: darkMode ? "white" : undefined }}>لماذا لايت سوفت</h2>
        <p>
          حلول مالية وإدارية متكاملة تجمع الكفاءة التشغيلية والامتثال عند الحاجة،
          مع فريق يرافقك من العرض حتى التشغيل.
        </p>
      </div>
      <div className="why-grid">
        {points.map((point) => (
          <article className="why-card" key={point.title}>
            <h3 style={{ color: darkMode ? "white" : undefined }}>{point.title}</h3>
            <p>{point.desc}</p>
          </article>
        ))}
      </div>
    </section>
  );
};

export default WhyLiteSoft;
